import { render, staticRenderFns } from "./chartjsBarChart.vue?vue&type=template&id=be23c658"
import script from "./chartjsBarChart.vue?vue&type=script&lang=js"
export * from "./chartjsBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports